import React from "react";
import { usePageStyles, StatusConfig } from "../styles/usePageStyles";

interface StatusTagProps {
  status: string;
  statusConfig?: StatusConfig;
  showDot?: boolean;
  className?: string;
  style?: React.CSSProperties;
}

/**
 * Status badge component with optional dot indicator
 */
export const StatusTag: React.FC<StatusTagProps> = ({
  status,
  statusConfig,
  showDot = true,
  className,
  style
}) => {
  const styles = usePageStyles(statusConfig);

  return (
    <span 
      style={{ ...styles.statusTag, ...style }} 
      className={className}
    >
      {showDot && <span style={styles.statusDot} />}
      {status}
    </span>
  );
};
